import React from 'react';
import { AttachmentFileAccessCell } from '../components/AttachmentFileAccessCell';
/** `dataKey`s this column sorts on, handed to the surface as `entitySortableColumns`. */
export const INVOICE_SORTABLE_COLUMNS = ['fileAccessLabel'];
/**
 * Invoice's single entity column — Visibility — inserted by the shared surface between Name and
 * Type. Everything else in that table is the surface's, identical across every attachment screen.
 *
 * Named "Visibility", not "Type" as the legacy table's header reads: that header is
 * `activerecord.attributes.invoice_attachment.file_access`, which translates to "Type" and would
 * sit directly beside the shared surface's own Type column (the *file* type). Two adjacent columns
 * both called Type, meaning different things, is not a label worth preserving for continuity.
 */
export function buildInvoiceColumns({ translateFn, invoiceId, readOnly }) {
    return [
        {
            dataKey: 'fileAccessLabel',
            label: translateFn('columns.visibility'),
            width: '160px',
            renderer: ({ item }) => (React.createElement(AttachmentFileAccessCell, { item: item, invoiceId: invoiceId, translateFn: translateFn, readOnly: readOnly }))
        }
    ];
}
